import styled from "styled-components";

export const TierPointsStyled = styled.div<{ color: string }>`
  text-align: center;
  .title {
    font-family: Bowlby One;
    font-style: normal;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 38px;
    line-height: 40px;
    color: ${(props) => props.color};
    display: block;
  }

  .subtitle {
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 800;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.01em;
    min-height: 22px;
    display: block;
  }
`;